import { parseResponsiveProperty } from '@converdy/styles'

const shapeMap = {
  round: 'data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTAwIDEwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48Y2lyY2xlIGN4PSI1MCIgY3k9IjUwIiByPSI1MCI+PC9jaXJjbGU+PC9zdmc+',
  square: 'data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjAwIDIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBjbGFzcz0ic3F1YXJlX3N2Z19fc3QwIiBkPSJNMCAwaDIwMHYyMDBIMHoiPjwvcGF0aD48L3N2Zz4=',
  blobOne: 'data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjAwIDIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTg4LjUgMzEuOWMxMi45IDE1LjkgMTIuNSA0My4zIDEwLjMgNzcuMXMtNi4yIDc0LjItMjYuMiA4Ni41LTU2LjEtMy4zLTg5LjQtMjEuMi02My43LTM4LjEtNzYuNC02OS44Qy01LjkgNzMtLjggMjkuOSAyMS42IDExLjcgNDQtNi40IDgzLjguNSAxMTYuNyA2LjFzNTkgMTAgNzEuOCAyNS44eiI+PC9wYXRoPjwvc3ZnPg==',
  blobTwo: 'data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjAwIDYwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNTU0LjYgMTY3LjhjNDUuNCA4MS40IDU1LjUgMTYxIDM2IDIzMS40LTE5LjQgNzAuNi02OC41IDEzMi4yLTEzNy4xIDE2Ny40LTY4LjQgMzUuNC0xNTYuMyA0NC4zLTI0NiAxOC41QzExNy45IDU1OS40IDI2LjMgNDk5IDUuMSA0MjAuN2MtMjEuNC03OC4xIDI3LjYtMTczLjkgOTYuNC0yNjAuNEMxNzAuNCA3NCAyNTkuMi0yLjkgMzQ0IC4xYzg0LjYgMy4xIDE2NS4yIDg2LjMgMjEwLjYgMTY3Ljd6Ij48L3BhdGg+PC9zdmc+',
}

export default function baseImageStyles({ width, customWidth = {}, shape }) {
  
  let obj = { }

  if (shape && shape !== 'natural') {

    const url = shapeMap[shape]
   
    Object.assign(obj, {
      '-webkit-mask-image': `url(${url})`,
      'mask-image': `url(${url})`,    
      'mask-mode': 'alpha',
      '-webkit-mask-repeat': 'no-repeat',
      'mask-repeat': 'no-repeat',
      '-webkit-mask-size': 'contain',
      'mask-size': 'contain',
      '-webkit-mask-position': 'center'
    }) 
    
  }
  
    if(width === 'custom') {

      Object.assign(obj, {
        ...parseResponsiveProperty(v => {
          return v && v.value && v.unit ? {
            width: v.value + v.unit,
          } : {} 
        }, customWidth)
      })

    }

  
  return obj
}
